export * from "./invite-user.component";
export * from "./invite-user.module";



// WEBPACK FOOTER //
// ./src/app/admin/invite-user/index.ts